import { IPermissionCheck } from './role';

export interface INavigation {
  id: number;
  label: string;
  link: string;
  icon?: string;
  altText?: string;
  subLabel?: string;
}

export class Navigation implements INavigation {
  id: number;
  label: string;
  link: string;
  icon?: string;
  altText?: string;
  subLabel?: string;

  static buildNavLinkList(permission: IPermissionCheck): INavigation[] {
    let navLinks: INavigation[] = [];
    if (permission.isSuperAdmin) {
      return (navLinks = [
        {
          id: 1,
          label: 'Units',
          link: '/admin/grade-units',
          icon: 'assets/img/book.png',
          altText: 'Units button',
        },
        {
          id: 2,
          label: 'Users',
          link: '/admin/users',
          icon: 'assets/img/Manage_Users.jpeg',
          altText: 'Users button',
        },
        {
          id: 3,
          label: 'Schools',
          link: '/admin/schools',
          icon: 'assets/img/school.png',
          altText: 'Schools button',
        },
        {
          id: 4,
          label: 'Profile',
          link: '/admin/profile',
          icon: 'assets/img/gear.png',
          altText: 'Profile button',
        },
        {
          id: 5,
          label: 'Avatars',
          link: '/admin/critters',
          icon: 'assets/img/cat.png',
          altText: 'Manage Avatar Image',
        },
        {
          id: 6,
          label: 'Languages',
          link: '/admin/languages',
          icon: 'assets/img/cartoon-usa-flag.png',
          altText: 'Manage Languages',
        },
      ]);
    } else if (permission.isAdmin) {
      return (navLinks = [
        {
          id: 1,
          label: 'Assignments',
          link: '/student',
          icon: 'assets/img/kitty_backpack.png',
          altText: 'Assignments button',
        },
        {
          id: 2,
          label: 'Users',
          link: '/admin/user-list',
          icon: 'assets/img/kitty_backpack.png',
          altText: 'Users button',
        },
        // {
        //   id: 3,
        //   label: 'Settings',
        //   link: '/admin/settings',
        //   icon: 'fa fa-cog',
        // },
      ]);
    } else if (permission.isTeacher) {
      const classroomId = sessionStorage.getItem('selectedClassroom');
      return (navLinks = [
        {
          id: 1,
          label: 'Classes',
          link: 'teacher/classes',
          icon: 'assets/img/apple.png',
          altText: 'Classes button',
        },
        {
          id: 2,
          label: 'Units',
          link: `teacher/grade-units`,
          icon: 'assets/img/book.png',
          altText: 'Units button',
        },
        {
          id: 3,
          label: 'Assignments',
          link: 'teacher/assignments',
          icon: 'assets/img/kitty_backpack.png',
          altText: 'Assignments button',
        },
        {
          id: 4,
          label: 'Notes Inbox',
          link: 'teacher/inbox',
          icon: 'assets/img/Inbox.png',
          altText: 'Notes inbox button',
        },
        {
          id: 5,
          label: 'Grades',
          link: 'teacher/grading',
          icon: 'assets/img/grades.png',
          altText: 'Grades button',
        },
        {
          id: 6,
          label: 'Easy Inbox',
          link: 'teacher/grading-inbox',
          icon: 'assets/img/highlighter.png',
          altText: 'Easy inbox button',
        },
        {
          id: 8,
          label: 'Prof. Dev.',
          link: '../../teacher/professional-development',
          icon: 'assets/img/eidelweiss.svg',
        },
        {
          id: 9,
          label: 'Community',
          link: 'teacher/communities',
          icon: 'assets/img/community.png',
          altText: 'Classroom Community button',
        },
        {
          id: 10,
          label: 'Profile',
          link: 'teacher/profile',
          icon: 'assets/img/gear.png',
          altText: 'Profile button',
        },
      ]);
    } else if (permission.isStudent) {
      return (navLinks = [
        {
          id: 1,
          label: 'Classes',
          link: 'student/classes',
          icon: 'assets/img/apple.png',
          altText: 'Classes button',
        },
        {
          id: 2,
          label: 'Units',
          link: 'student/grade-units',
          icon: 'assets/img/book.png',
          altText: 'Units button',
        },
        {
          id: 3,
          label: 'Assignments',
          link: 'student/assignments',
          icon: 'assets/img/kitty_backpack.png',
          altText: 'Assignments button',
        },
        {
          id: 4,
          label: 'Retry Inbox',
          link: 'student/inbox',
          icon: 'assets/img/pencil.png',
          altText: 'Grades button',
        },
        {
          id: 5,
          label: 'Grades',
          link: 'student/grading',
          icon: 'assets/img/grades.png',
          altText: 'Grades button',
        },
        {
          id: 6,
          label: 'Community',
          link: 'student/classroom-communities',
          icon: 'assets/img/community.png',
          altText: 'Classroom Community button',
        },
        {
          id: 7,
          label: 'Utility',
          link: 'student/profile',
          icon: 'assets/img/gear.png',
          altText: 'Profile button',
        },
      ]);
    } else if (!permission.isEnrolled) {
      return (navLinks = []);
    }

    return (navLinks = [
      {
        id: 1,
        label: 'Assignments',
        link: '/student',
        icon: 'assets/img/kitty_backpack.png',
        altText: 'Assignments button',
      },
    ]);
  }

  static buildProfileLinkList(): INavigation[] {
    const profileLinks: INavigation[] = [
      {
        id: 1,
        label: 'Profile',
        link: '/user/profile',
        icon: 'assets/img/gear.png',
        altText: 'Profile button',
      },
    ];

    return profileLinks;
  }

  constructor(configOverride?: INavigation) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
